import { createSlice, PayloadAction } from "@logicsoftware/redux-toolkit";

const initialState: Dictionary<any> = null;

const personalizationSlice = createSlice({
    name: "Personalization",
    initialState,
    reducers: {
        setPersonalization: (state, action: PayloadAction<any>) => ({
            ...state,
            ...action.payload,
        }),
    },
});

export const { setPersonalization } = personalizationSlice.actions;
export const personalizationReducer = personalizationSlice.reducer;
